module.exports = __webpack_public_path__ + "assets/img/_Novo RDR_Library_RGB_lr.f9f7d4e2.jpg";